module.exports = __webpack_public_path__ + "img/img14.e51e5013.jpg";